export default "__VITE_ASSET__BuDr1RFF__"